import { render, staticRenderFns } from "./loading-block.vue?vue&type=template&id=630f9c82&scoped=true"
import script from "./loading-block.ts?vue&type=script&lang=ts&external"
export * from "./loading-block.ts?vue&type=script&lang=ts&external"
import style0 from "./loading-block.vue?vue&type=style&index=0&id=630f9c82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630f9c82",
  null
  
)

export default component.exports